'use strict';

/**
 * @module common.filters
 */

var filters = angular.module('common.filters', []);

var GroupRole = require('./GroupRole');

filters.filter('groupRole', [
  GroupRole
]);


// WEBPACK FOOTER //
// ./src/common/filters/index.js